/**
 * Created by iamso on 18.11.2021
 */

const RuinsView = cc.Node.extend({
    ctor: function (ruins, unitParentView) {
        this._super();

        this.ruins = ruins;
        this.unitView = unitParentView;

        this.restoreState();
        cleverapps.bundleLoader.ensureSoundsLoaded(bundles.merge.urls.ruins_explode);
    },

    restoreState: function () {
        if (cleverapps.gameModes.hideTankProgress || !this.ruins.getTimeLeft()) {
            this.removeTimer();
        } else {
            this.createTimer();
        }
    },

    createTimer: function () {
        const styles = cleverapps.styles.RuinsView.timer;
        const timer = new ComponentTimer(new cleverapps.CountDown(this.ruins.getTimeLeft()), Ruins.LIFETIME, {
            withoutBar: true,
            showHours: false
        });
        timer.setAlignment(styles);
        this.unitView.createAdditionalView("timer", timer);
    },

    removeTimer: function () {
        this.unitView.removeAdditionalView("timer");
    },

    blowUp: function (tierName) {
        cleverapps.effects.fire("merge.ruins.explode");
        this.unitView.sprite.setAnimation(0, tierName === "cheap" ? "boom_small" : "boom_big", false);
        this.unitView.sprite.setCompleteListener(() => {
            this.unitView.removeFromParent();
        });
        this.unitView.sprite.setSafeToRemove();
    }
});

cleverapps.styles.RuinsView = {
    timer: {
        x: { align: "center" },
        y: { align: "bottom" }
    }
};